import { Response } from '@angular/http';
import { MessageCount, MultiSelect } from './models/messages.model';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */

import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';

import { Message, MessagesList, MessageBody } from './models/messages.model';
import { MessagesService } from './services/messages.service';
import { NotificationService } from './services/notification.service';
import { ExperienceService } from '../../services/experience.service';

// Store
import { Store } from '@ngrx/store';

// UI Actions
import * as thresholdActions from '../../store/actions/actions';
import { Subscription } from 'rxjs';
import { ToasterService } from './services/toast/toast.service';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'celine-notifications',
  encapsulation: ViewEncapsulation.Emulated,
  template: require('./notifications.component.html'),
  styles: [`
	.notifications { 
		font-size: 14px;
		width: 362px;
		padding: 1rem;
		border-spacing:0 5px;
	}
	.search-bar {
		padding-left: 14px;
		width: 396px;
		padding-top: 10px;
	}
	.truncate {
		white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
	}
	.no-results {
		text-align: center;
		margin: 26% auto;
		font-size: 21px;
		color: #636363;
	}
	.card {
		width: 100%;
	}
	.card-block p {
		padding-left: 0px;
	}
	.checkbox {
		opacity: 0;
		position: absolute;
		height: 0;
		width: 0;
	}
	.custom-control-input {
		position: relative;
	}
	.custom-control.custom-checkbox {
		padding-left: 1rem;
		padding-top: 1px;
	}
	
	.checkbox-label input:Checked ~ .checkbox-select-all {
		background-color: grey;
		boarder-radius: 3px;
	}
	.checkbox-padding {
		padding-left: 16px;
	}
	.unread {
		font-weight: bold;
		color: black;
	}
	.read {
		width: 10px;
		margin-right: 10px;
		display: inline-block;
	}
	.table-data {
		border-top:1px solid #ddd;
		border-left: none;
		border-right: none;
		color:#555555;
	}
	.table-data-content {
		padding-left: 10px;
		padding-top: 1rem;
		padding-bottom: 1rem;
		font-size: 14px;
		font-weight: normal;
		color:#555555;
		width: 67%;
	}
	.table-data-date {
		padding-right: 1rem;
	}
	.table-data:hover {
		background-color: rgba(167, 158, 158, 0.3);
		cursor: pointer;
	}
	.open-message {
		background-color: #F5F5F5;
	}
	.table-list {
		margin-left: 20px;
		margin-right: 20px;
	}
	.card-block {
		width: 1137px;
		height: 520px;
	}
	.list {
		width: 421px;
		text-align: justify; 
		padding-left: 24px;
		padding-right: 24px;
		max-height: 380px;
		overflow-x: auto;
		overflow-y : auto;
	}
	.wgt-static__action {
		margin-top: 35px;
	}
	.message-view {
		height: 490px;
		text-align: inherit;
		padding-top:10px;
		padding-left: 2rem;
		border-left:1px solid #ddd;
	}
	.message-view > p {
		font-size: 14px;
		color:#555555;
	}
	.message-body {
		max-height: 380px;
		padding-bottom: 32px;
		padding-right: 10px;
		overflow-x: auto;
		overflow-y : auto;
	}
	
	.view-message-body {
		font-size: 16px;
		line-height: 1.5;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	.sol-loader-message{
		left: 25%;
    	position: relative;
    	margin-top: 50px;
	}
	.global-buttons {
        display: inline-flex;
        padding-left: 40px;
        margin-bottom: 12px;
    }
    .btn-padding {
        padding-left: 10px;
        display: inline;
        cursor: pointer;
    }
    .checkbox-select-all{
        height: 10px;
        width: 10px;
        margin-right: 10px;
        border-radius: 3px;
        border: 2px solid grey; 
        padding-right: 16px;
        cursor: pointer;
    }
    .ico-more-vertical{
        font-size: 19px;
		padding-left: 18px;
		cursor: pointer;
    }
    .dropdown-toggle:after {
		display: none;
	}
	
    .dropdown-item {
        cursor: pointer;
    }

	.dropdown-menu {
		box-shadow: 2px 3px 4px 3px #cfcfcf;
	}
	.disabled {
		cursor: default;
	}
    .ico-refresh-cw {
        font-size: 19px;
	}
	.select-wrapper{
		margin: 0 15px 20px 15px;
	}
	.selected-item {
		width:60px;
		padding: 7px 10px 0px 10px;
		border-radius: 5px;
		cursor: pointer;
		color: #555;
		display: -ms-flexbox;
		display: flex; 
		height: 100%;
		border:1px solid #333;

	}
	.custom-btn button.btn{
		color: #2d2323;
		background-color: #fff;
		border-color: 1px solid #af144b;
	}
	.custom-btn button.btn:hover{
		color: #2d2323;
		background-color: #fff;
		border-color: 1px solid #af144b;
	}
	.ico-chevron-down {
		position:absolute;
		left: 35px;
		top: 10px;
	}
	.custom-dropdown {
		position: absolute;
		top: 31px;
		min-width: 60px;
		width: auto;
		background: #fff;
		border: 1px solid #333;
		z-index: 999;
		border-radius: 0 0 5px 5px;
	}
	.dropdown-item {
		padding: 0px 1rem;
	}
	.btn.btn-link i, .btn i{
		margin:0;
	}
	.show>.dropdown-menu{
		box-shadow:none;
	}
	/* width */
	::-webkit-scrollbar {
		width: 9px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: #d8d8d8;
		border-radius: 5px;
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		width: 9px;
		height: 60px;
		border-radius: 5px;
		background: #555555; 
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
`]
})

export class NotificationsComponent implements OnInit {

  public messagesUnreadCount: number;
  public loading: boolean = false;
  public messageLoading: boolean = false;
  public subscription: Subscription;
  public totalItems: number;
  public pageSize: number = 25;
  public activePage: number = 1;
  public selectedPageSize: number;
  public allMessagesList: Message[] = [];
  public optionsArray = ['Mark as read', 'Mark as unread', 'Delete'];
  public dropDownClicked: boolean = false;
  public selectedMessage: Message;
  public timer = 0;
  public reactiveModel = {
    searchInput: ''
  }
  public searchInput: FormControl;
  public reactiveForm: FormGroup;
  public toastService: any;
  public selectAllCheckbox: boolean = false;
  public pageSizes: number[] = [25, 50, 75, 100];
  public buttonRedirecting: boolean = false;
  @ViewChild('warning') warning: TemplateRef<any>;
  /**
   *
   */
  constructor(
    private experienceService: ExperienceService,
    private messagesService: MessagesService,
    private store: Store<any>,
    private notificationService: NotificationService,
    private toasterService: ToasterService,
    private modalService: NgbModal) {

    setTimeout(() => {
      this.store.dispatch(new thresholdActions.SetBannerTitleAction('Your workflow inbox'));
      this.store.dispatch(new thresholdActions.SetApplicationTitleAction("Your workflow inbox"));
      this.store.dispatch(new thresholdActions.ShowBannerAction());
      this.store.dispatch(new thresholdActions.SetColorAction('#fff'));
      this.store.dispatch(new thresholdActions.SetVariantAction('jumbo-variant-dark'));
      this.store.dispatch(new thresholdActions.SetBannerBackgroundAction(''));
      this.store.dispatch(new thresholdActions.SetSizeAction('sol-jumbo-h1'));
      this.store.dispatch(new thresholdActions.HideContextNavAction());
      this.store.dispatch(new thresholdActions.HideMenuAction());
      this.store.dispatch(new thresholdActions.HideProfileBannerAction());
      this.store.dispatch(new thresholdActions.SetDynamicMenuAction([]));

      // Setup menu
      let mainNav: any[] = [
        { title: 'Dashboard', routerPath: '' },
        { title: 'Workflow Inbox', routerPath: 'notifications' }
      ];
      this.store.dispatch(new thresholdActions.SetMainMenuAction(mainNav));
      this.store.dispatch(new thresholdActions.ShowMainMenuAction());
    });

    this.searchInput = new FormControl(this.reactiveModel.searchInput);
    this.reactiveForm = new FormGroup({
      searchInput: this.searchInput
    });
  }

	/**
	 * 
	 */
  ngOnInit(): void {
    this.setMessagesList(this.activePage, this.pageSize);
  }

  public viewMessage(message: Message) {
    this.setMessageBody(message);
    this.updateMessageReadStatus(message);
  }

  public searchTermList(searchValue: FormControl) {
    if (searchValue.value.length >= 1) {
      this.setMessagesList(this.activePage, this.pageSize, searchValue.value);
    } else if (searchValue.value.length === 0) {
      this.setMessagesList(this.activePage, this.pageSize);
    }
  }

  public setMessagesList(pageNumber: number, pageSize: number, searchQuery?: string, reset?: boolean) {

    this.selectAllCheckbox = false;
    this.loading = true;
    if (reset) {
      this.resetModel();
    }


    this.messagesService.getMessagesList(pageNumber, pageSize, searchQuery).subscribe((data: MessagesList) => {
      this.setMessages(data);
      this.loading = false;
    },
      (response) => {
        this.loading = false;
        this.toasterService.warning('Warning', 'An error has occurred please try again later');
      });
  }

  public onPageChange(pageNumber: number, pageSize: number, searchInput: FormControl) {
    if (pageNumber !== this.activePage) {
      this.setMessagesList(pageNumber, pageSize, searchInput.value);
    }
  }

  public onPageSizeChange(pageSize: number, searchInput: FormControl) {
    if (pageSize !== this.pageSize) {
      this.setMessagesList(this.activePage, pageSize, this.searchInput.value);
    }
  }

  public delay(value: FormControl, ms: number) {
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(this.searchTermList.bind(this, value), ms)
  }

  public selectItem() {
    this.selectAllCheckbox = this.getSelectedMessages().length === this.allMessagesList.length;
  }

  public selectAll() {
    this.allMessagesList.forEach(item => item.isSelected = this.selectAllCheckbox);
  }

  public updateNotificationState(index: number) {
    let selectedMessages = this.getSelectedMessages();
    if (!selectedMessages.length) {
      return null;
    } else {

      this.resetModel();
      let status = index == 0 ? 1 : 0;
      switch (index) {
        case 0:
        case 1:
          let jsonObject = { messageIds: selectedMessages, status: status }
          this.messagesService.updateMessageStatus(jsonObject).subscribe(() => {
            this.setMessagesList(this.activePage, this.pageSize);
          },
            (error) => {
              this.toasterService.error('Error', 'Unable to update status, please try again later.');
            });
          break;
        case 2:
          this.softDeletePrompt(this.warning, 'sm');
          break;
        default:
          return null;
      }
    }
  }

  private softDeletePrompt(content: any, modalSize?: string) {
    let options: any = modalSize ? { size: modalSize } : {};

    this.modalService.open(content, options).result.then((result) => {
      this.softDelete(result);
    }, (reason) => {
      return null;
    });
  }

  private softDelete(bool: boolean) {
    if (!bool) {
      return null;
    } else if (bool) {
      let test = { messageIds: this.getSelectedMessages() }
      this.messagesService.softDelete(test).subscribe((result) => {
        this.setMessagesList(this.activePage, this.pageSize);
        this.toasterService.success('Success', 'Message(s) deleted');
      },
        (error) => { this.toasterService.error('Error', 'Unable to delete message(s), please try again later.'); });
    }
  }

  private updateMessageReadStatus(selectedMessage: Message) {
    if (selectedMessage && (selectedMessage.messageStatus === 0)) {
      this.allMessagesList = this.setMessageUnreadStatus(selectedMessage);
      this.messagesService.updateMessageCount(selectedMessage).subscribe((response) => {
        this.getMessageListUnreadCount();
      },
        (error) => { this.toasterService.error('Error', 'Unable to update status, please try again later.'); });
    }
  }

  private setMessageUnreadStatus(selectedMessage: Message) {
    if (this.messagesUnreadCount >= 0) {
      return this.allMessagesList.map((current) => {
        if (current.messageId === selectedMessage.messageId) {
          current.messageStatus = 1;
        }
        return current;
      })
    }
  }

  private getMessageListUnreadCount() {
    this.messagesService.getUnreadMessages().subscribe((response: MessageCount) => {
      if (response.unreadMessages >= 0) {
        this.messagesUnreadCount = response.unreadMessages;
      } else {
        this.messagesUnreadCount = 0;
      }
      this.notificationService.setNotificationCount(this.messagesUnreadCount);
    },
      (error) => {
        this.messageLoading = false;
        this.toasterService.warning('Warning', 'An error has occurred please try again later');
      });
  }

  private getSelectedMessages() {
    return this.allMessagesList.filter(x => x.isSelected).map(x => x.messageId);
  }

  private setMessages(data: MessagesList) {
    this.selectedMessage = data.messages[0];
    if (data.messages.length) {
      this.selectedMessage.body = this.selectedMessage.body.replace(new RegExp('\n', 'g'), "<br />");
    }
    this.allMessagesList = data.messages;
    this.totalItems = data.totalMessages;
    this.pageSize = data.pageSize;
    this.activePage = data.pageNumber;
    this.selectedPageSize = data.pageSize;
    this.getMessageListUnreadCount();
  }

  private resetModel() {
    this.searchInput.setValue('');
  }

  private setMessageBody(message: Message) {
    if (message.messageId !== this.selectedMessage.messageId) {
      this.messageLoading = true;

      return this.messagesService.getMessagesBody(message.messageId).subscribe((message: MessageBody) => {
        let currentIndex: number;
        this.allMessagesList.map((current, index) => {
          if (current.messageId === message.messageId) {
            currentIndex = index;
            current.body = message.body.replace(new RegExp('\n', 'g'), "<br />");
            current.action = message.action;
          }
          return current;
        })
        this.selectedMessage = this.allMessagesList[currentIndex];
        this.messageLoading = false;
      },
        (error) => {
          this.messageLoading = false;
          this.toasterService.warning('Warning', 'An error has occurred please try again later');
        });
    }
  }

  public actionButton(url: string) {
    let celineVersion = this.experienceService.getCelineVersion(url);
    if (celineVersion === null) {
      this.toasterService.error('Error', 'You do not have access to request application');
    } else {
      this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true)); // allow redirects
      this.buttonRedirecting = true; // disabled button... stop user from clicking multiple times

      let constructUrl = url;

      if (this.isUrl(url)) {
        constructUrl = url;
      } else {
        // make sure url contains prefixed `/`
        if (url && (url.charAt(0) !== '/')) constructUrl = `/${constructUrl}`
        constructUrl = `/#${constructUrl}` // append `/#`
        if (celineVersion === 2) constructUrl = `/v2${constructUrl}`
      }

      // give dispatch 2secs
      setTimeout(() => {
        window.location.href = constructUrl;
      }, 3000);
    }
  }

  private isUrl(s) {
    var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
    return regexp.test(s);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/notifications/notifications.component.ts